import React from "react";
import { observer } from "mobx-react";
import { observable, action } from "mobx";
import { injectIntl } from "react-intl";
import { Button, Panel, Collapse } from "react-bootstrap";
import EditableLabel from "./EditableLabel";

@injectIntl
@observer
export default class LabelsManagePanel extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  @observable showLabelInput = false;
  @observable labelName = "";

  render() {
    const { note, intl } = this.props;

    return (
      <Collapse in={note.showLabelManagePanel}>
        <Panel>
          {/*{intl.formatMessage({id: 'manage_tags'})}*/}

          {!this.showLabelInput && (
            <Button
              bsStyle="primary"
              onClick={this.toggleLabelInput}
              style={{ marginBottom: "15px" }}
            >
              {intl.formatMessage({ id: "create_new_tag" })}
            </Button>
          )}

          {this.showLabelInput && (
            <input
              className="form-control"
              type="text"
              autoFocus={true}
              onChange={action(e => (this.labelName = e.target.value))}
              onKeyDown={this.handleKeyDown}
              onBlur={this.finishEdit}
              value={this.labelName}
            />
          )}

          {note.rootStore.valueProposition.labels.map((label, index) => (
            <EditableLabel label={label} note={note} key={index} />
          ))}

          <hr />
          <Button
            block
            onClick={() => note.toggleLabelsManagePanel()}
            style={{ marginBottom: "15px" }}
          >
            {intl.formatMessage({ id: "done" })}
          </Button>
        </Panel>
      </Collapse>
    );
  }

  @action
  addTag = () => {
    const { note, intl } = this.props;

    note.addVPLabel(this.labelName);

    this.labelName = "";
  };

  @action
  finishEdit = e => {
    e.preventDefault();

    if (this.labelName.trim()) {
      this.addTag();
    }

    this.toggleLabelInput();
  };

  @action
  handleKeyDown = e => {
    if (e.key === "Enter") {
      this.finishEdit(e);
    }
  };

  @action
  toggleLabelInput = () => {
    this.showLabelInput = !this.showLabelInput;
  };
}
